import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-sftp-report-dw",
  templateUrl: "./sftp-report-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SftpReportDwComponent {
  filters: string[] = [];
  dashboardType = LookerRiskDashboardType.SFTP_REPORT_DW;
  hideFilters: string[] = [HideFilters.ORG_ID, HideFilters.USER_ID];
}
